export interface ServiceDetail {
  sections: {
    title: string;
    content: string;
  }[];
}

export const SERVICE_DETAILS: Record<string, ServiceDetail> = {
  "Carbon Laser Facial": {
    sections: [
      {
        title: "Refresh Your Skin",
        content:
          "Experience the rejuvenating effects of a Carbon Laser Facial, a non-invasive treatment that refreshes your skin. The procedure helps reduce signs of aging, sun damage, and uneven skin tone, leaving you with a smoother and more radiant complexion.",
      },
      {
        title: "Deep Cleansing Action",
        content:
          "The Carbon Laser Facial involves the application of a special carbon lotion to your skin, which acts as a magnet for impurities. When the laser is applied, it targets and removes the carbon particles along with dead skin cells, unclogging pores and promoting a deep cleansing action. This process can result in improved skin texture and minimized pore size.",
      },
      {
        title: "Minimal Downtime, Maximum Results",
        content:
          "Enjoy the benefits of a Carbon Laser Facial with minimal downtime. The procedure is quick and virtually painless, making it an ideal option for individuals with busy lifestyles. Achieve maximum results in just a few sessions, and reveal a revitalized, glowing complexion that reflects your natural beauty",
      },
    ],
  },
  "Full Body Laser Hair Reduction": {
    sections: [
      {
        title: "Smooth Skin Forever",
        content:
          "Advanced laser technology targets hair follicles at the root, providing a long-term solution for unwanted hair. Say goodbye to the daily hassle of shaving and the pain of waxing.",
      },
      {
        title: "Safe for All Skin Types",
        content:
          "Our US FDA-approved lasers are safe and effective for various skin tones and hair types, ensuring a comfortable experience with minimal risk of irritation or side effects.",
      },
      {
        title: "Precision and Speed",
        content:
          "Treat large areas like legs or back quickly and precisely. Most patients see significant hair reduction in just a few sessions, revealing smooth, hair-free skin.",
      },
    ],
  },
  "Laser Photo Facial": {
    sections: [
      {
        title: "Collagen Boost",
        content:
          "Stimulates natural collagen production to firm and tighten the skin, effectively reducing the appearance of fine lines, wrinkles, and enlarged pores.",
      },
      {
        title: "Even Tone",
        content:
          "Targets redness, sun spots, and various forms of pigmentation to create a more uniform, clear, and youthful complexion.",
      },
      {
        title: "Radiant Rejuvenation",
        content:
          "A quick, non-invasive procedure that leaves your skin looking brighter and more refreshed with absolutely no recovery time needed.",
      },
    ],
  },
  "PRP Facial": {
    sections: [
      {
        title: "Natural Healing",
        content:
          "Uses your own blood's platelets to stimulate cell turnover and collagen production for natural skin renewal and repair.",
      },
      {
        title: "Youthful Texture",
        content:
          "Improves skin texture, reduces fine lines, and helps with acne scarring, giving you a smoother, more youthful and healthy appearance.",
      },
      {
        title: "Safe and Effective",
        content:
          "Since it uses your own biological material, there's no risk of allergic reactions or rejection, making it a highly safe and natural aesthetic procedure.",
      },
    ],
  },
  "Bridal Skincare": {
    sections: [
      {
        title: "Customized Glow",
        content:
          "A tailored skincare regimen designed to address your specific concerns and ensure you look absolutely radiant on your wedding day.",
      },
      {
        title: "Flawless Complexion",
        content:
          "Combines various treatments to clear acne, even out skin tone, and deeply hydrate the skin for a perfect, camera-ready bridal look.",
      },
      {
        title: "Stress-Free Prep",
        content:
          "Start your journey months in advance with expert guidance, ensuring your skin is at its absolute best for your special occasion.",
      },
    ],
  },
  "Acne Treatment": {
    sections: [
      {
        title: "Targeted Solutions",
        content:
          "Professional medical treatments that address the root causes of acne, including bacteria, inflammation, and excess oil production.",
      },
      {
        title: "Clearer Skin",
        content:
          "Reduces active breakouts and prevents future ones, helping you achieve a consistently clear, healthy, and blemish-free complexion.",
      },
      {
        title: "Expert Guidance",
        content:
          "Receive a personalized home-care routine and clinical treatments tailored specifically to your skin type and acne severity.",
      },
    ],
  },
  "Scar Treatment": {
    sections: [
      {
        title: "Diminish Scars",
        content:
          "Advanced procedures like microneedling or laser therapy to significantly reduce the appearance of acne scars, surgical scars, or injury marks.",
      },
      {
        title: "Boost Confidence",
        content:
          "Improve skin texture and smoothness, helping you feel more comfortable and confident in your own skin by minimizing visible imperfections.",
      },
      {
        title: "Tailored Approach",
        content:
          "Every scar is different; our experts choose the best combination of treatments for your specific scar type and skin condition for optimal results.",
      },
    ],
  },
  Pigmentations: {
    sections: [
      {
        title: "Brighten Skin",
        content:
          "Effectively targets melasma, sun spots, and post-inflammatory hyperpigmentation for a clearer, brighter, and more even look.",
      },
      {
        title: "Safe Procedures",
        content:
          "Uses clinically proven methods to break down excess melanin without damaging the surrounding skin tissue, ensuring safety and efficacy.",
      },
      {
        title: "Long-lasting Results",
        content:
          "Achieve an even skin tone and learn how to maintain it with proper sun protection and a customized medical skincare routine.",
      },
    ],
  },
  "Vampire Facial": {
    sections: [
      {
        title: "Advanced Rejuvenation",
        content:
          "Combines microneedling with Platelet-Rich Plasma (PRP) for intense skin renewal, repair, and significant anti-aging benefits.",
      },
      {
        title: "Deep Penetration",
        content:
          "Microneedling creates tiny channels that allow the PRP to reach deeper layers of the skin for maximum effectiveness and cell stimulation.",
      },
      {
        title: "Natural Glow",
        content:
          "Promotes the growth of new, healthy skin cells, resulting in a vibrant, refreshed, and youthful complexion that radiates health.",
      },
    ],
  },
  "RF Skin Tightening": {
    sections: [
      {
        title: "Non-Surgical Lift",
        content:
          "Uses radiofrequency energy to heat the deep layers of the skin, causing immediate collagen contraction and long-term remodeling.",
      },
      {
        title: "Firmer Skin",
        content:
          "Effectively tightens loose skin on the face, neck, and body, providing a more contoured, lifted, and youthful appearance.",
      },
      {
        title: "No Downtime",
        content:
          "A comfortable, non-invasive procedure that allows you to return to your daily activities immediately after treatment.",
      },
    ],
  },
  "Hair Transplants": {
    sections: [
      {
        title: "Natural Restoration",
        content:
          "Advanced FUE or FUT techniques to restore thinning hair with natural-looking results that blend seamlessly with your existing hair.",
      },
      {
        title: "Expert Precision",
        content:
          "Performed by skilled surgeons who ensure proper hairline design and graft placement for optimal density and aesthetic appeal.",
      },
      {
        title: "Permanent Solution",
        content:
          "Transplanted hair follicles are resistant to balding, providing a permanent and life-changing fix for hair loss.",
      },
    ],
  },
  Physiotherapy: {
    sections: [
      {
        title: "Healing Through Movement",
        content:
          "Personalized exercise programs and manual therapy to restore mobility, strength, and function after injury, surgery, or chronic conditions.",
      },
      {
        title: "Pain Management",
        content:
          "Effective techniques to reduce chronic pain and prevent future injuries, significantly improving your overall quality of life.",
      },
      {
        title: "Holistic Care",
        content:
          "Addresses the root cause of physical issues, not just the symptoms, for long-term health, recovery, and peak physical performance.",
      },
    ],
  },
  Mesotherapy: {
    sections: [
      {
        title: "Nutrient Infusion",
        content:
          "Micro-injections of vitamins, minerals, and amino acids directly into the skin to nourish, hydrate, and rejuvenate from within.",
      },
      {
        title: "Versatile Benefits",
        content:
          "Effective for skin hydration, anti-aging, and even treating certain types of hair loss by stimulating the scalp and follicles.",
      },
      {
        title: "Quick and Targeted",
        content:
          "A minimally invasive procedure that delivers active ingredients exactly where they are needed for fast and visible results.",
      },
    ],
  },
  "Dermal Fillers": {
    sections: [
      {
        title: "Restore Volume",
        content:
          "Instantly adds volume to areas like cheeks, lips, and under-eyes to create a more youthful, plump, and balanced facial profile.",
      },
      {
        title: "Smooth Lines",
        content:
          "Effectively fills in deep wrinkles and folds, such as nasolabial folds, for a smoother and more refreshed appearance.",
      },
      {
        title: "Natural Results",
        content:
          "Our experts use high-quality fillers and precise techniques to ensure your results look natural and subtly enhance your features.",
      },
    ],
  },
  Botox: {
    sections: [
      {
        title: "Smooth Wrinkles",
        content:
          "Temporarily relaxes the muscles that cause dynamic wrinkles, such as crow's feet, forehead lines, and frown lines.",
      },
      {
        title: "Youthful Look",
        content:
          "Achieve a refreshed and well-rested appearance with a quick, minimally invasive treatment that yields impressive results.",
      },
      {
        title: "Preventative Care",
        content:
          "Regular treatments can help prevent the formation of deeper, permanent lines over time by reducing muscle strain on the skin.",
      },
    ],
  },
  "Anti Aging Treatment": {
    sections: [
      {
        title: "Comprehensive Care",
        content:
          "A combination of advanced procedures and medical-grade skincare to address all signs of aging holistically.",
      },
      {
        title: "Total Renewal",
        content:
          "Targets fine lines, wrinkles, sagging skin, and age spots for a complete and effective facial rejuvenation.",
      },
      {
        title: "Expert Strategy",
        content:
          "Receive a long-term anti-aging plan tailored to your skin's unique needs, lifestyle, and aging process.",
      },
    ],
  },
  "Glutathione Therapy": {
    sections: [
      {
        title: "Skin Brightening",
        content:
          "A powerful antioxidant that helps lighten skin tone and reduce the appearance of dark spots and hyperpigmentation from within.",
      },
      {
        title: "Detoxification",
        content:
          "Boosts your body's natural detoxification processes, leading to improved overall health and a clearer, more radiant complexion.",
      },
      {
        title: "Wellness Boost",
        content:
          "Enhances immune function and energy levels while providing significant aesthetic benefits for your skin's health.",
      },
    ],
  },
  "IV infusions": {
    sections: [
      {
        title: "Instant Hydration",
        content:
          "Delivers essential fluids, vitamins, and minerals directly into the bloodstream for 100% absorption and immediate effect.",
      },
      {
        title: "Radiant Skin",
        content:
          "Specialized 'glow' infusions packed with antioxidants and vitamins to brighten skin, improve texture, and boost radiance.",
      },
      {
        title: "Recovery and Immunity",
        content:
          "Perfect for boosting energy, recovering from illness or fatigue, or maintaining peak physical and mental performance.",
      },
    ],
  },
  "Tattoo Removal": {
    sections: [
      {
        title: "Safe Clearance",
        content:
          "Advanced laser technology breaks down tattoo ink particles safely so your body can naturally eliminate them over time.",
      },
      {
        title: "All Colors",
        content:
          "Effective on a wide range of ink colors and tattoo sizes, with advanced settings to minimize risk to the surrounding skin.",
      },
      {
        title: "Clear Skin",
        content:
          "Achieve complete or significant removal over a series of sessions, restoring your skin's natural and clear appearance.",
      },
    ],
  },
  "Non Surgical Fat Reduction": {
    sections: [
      {
        title: "Body Contouring",
        content:
          "Advanced non-invasive technology to contour your body and reduce stubborn fat without surgery or downtime.",
      },
      {
        title: "Targeted Fat Loss",
        content:
          "Targets specific areas like the abdomen, thighs, and arms, breaking down fat cells naturally for a slimmer, more toned appearance.",
      },
      {
        title: "Safe & Effective",
        content:
          "A clinically proven alternative to liposuction that provides visible results with minimal discomfort and no recovery period.",
      },
    ],
  },
  Rhinoplasty: {
    sections: [
      {
        title: "Facial Harmony",
        content:
          "Expert nose reshaping procedures designed to enhance your facial balance and overall aesthetic harmony.",
      },
      {
        title: "Precision Reshaping",
        content:
          "Whether for cosmetic or functional reasons, our specialists use advanced techniques to achieve the perfect shape and size for your nose.",
      },
      {
        title: "Boost Confidence",
        content:
          "Achieve the look you've always wanted with a personalized approach that prioritizes natural-looking results and patient satisfaction.",
      },
    ],
  },
  "All Dental Subspecialties": {
    sections: [
      {
        title: "Advanced Oral Care",
        content:
          "Comprehensive dental solutions including aesthetic smile designing, dental implants, and professional teeth whitening in a luxury clinical environment.",
      },
      {
        title: "Expert Subspecialties",
        content:
          "Our team of specialists handles everything from painless root canals and orthodontics to complex oral surgeries with precision and care.",
      },
      {
        title: "Holistic Wellness",
        content:
          "We believe in the connection between oral health and overall well-being, providing treatments that enhance both your smile and your health.",
      },
    ],
  },
  "Skin Boosters/Stem Cells": {
    sections: [
      {
        title: "Cellular Renewal",
        content:
          "Cutting-edge bio-remodelling treatments using high-concentration hyaluronic acid and stem cell therapy to trigger deep tissue repair and rejuvenation.",
      },
      {
        title: "Luminous Radiance",
        content:
          "Achieve a natural, lit-from-within glow with treatments that improve skin elasticity, hydration, and overall texture at a cellular level.",
      },
      {
        title: "Scientific Beauty",
        content:
          "Experience the next generation of aesthetic medicine with safe, regenerative procedures that provide long-lasting, natural-looking volume and skin health.",
      },
    ],
  },
  "Medi - HydraFacial": {
    sections: [
      {
        title: "The Ultimate Facial",
        content:
          "A premium 6-step medical facial that combines vortex-cleansing, chemical peeling, and automated extractions for unparalleled skin clarity.",
      },
      {
        title: "Antioxidant Infusion",
        content:
          "Deeply nourish your skin with a unique infusion of antioxidants, peptides, and hyaluronic acid for immediate, visible results and a healthy glow.",
      },
      {
        title: "Customized Precision",
        content:
          "We tailor every HydraFacial to your specific skin concerns, whether it's fine lines, hyperpigmentation, or congested pores, ensuring optimal outcomes.",
      },
    ],
  },
};
